module.exports = __webpack_public_path__ + "static/media/blue.061ab0b0.jpg";